import confetti from '../assets/confetti.png'
import { useEffect } from 'react';

export default function PaymentSuccess(props) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    
    <div className="payment-success-container">
        <img src={confetti} alt="confetti" className="payment-success-confetti" />
        <h1 className="payment-success-title">Congratulations!</h1>
        <h2 className="payment-success-subtitle">
            You've given the gift of a lifetime. Check your email for the gift certificate.
        </h2>
        <div className="payment-success-next-steps">
            <h1 className="payment-success-next-steps-title">Next Steps</h1>
            <h2 className="payment-success-next-steps-subtitle">
                At this point, you can give the gift certificate to the recipient whenever and however you'd like. Forward the email or go old-school and print it out and stuff it in an envelope—it's up to you!
            </h2>
            <h3 className="payment-success-reference-number-label">
                REFERENCE NUMBER: <span className="payment-success-reference-number">#{props.referenceNumber}</span>
            </h3>
        </div>
    </div>
  );
}
